import React from 'react';
import { IconProps } from '.';

const SvgTableGeneral = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M3.5 3.5v17h17v-17h-17ZM7.875 5H5v3.375h2.875V5Zm1.25 0v3.375H19V5H9.125Zm-1.25 4.625H5v2.25h2.875v-2.25Zm1.25 2.25v-2.25H19v2.25H9.125Zm-1.25 1.25H5v2.25h2.875v-2.25Zm1.25 2.25v-2.25H19v2.25H9.125Zm-1.25 1.25H5V19h2.875v-2.375ZM9.125 19v-2.375H19V19H9.125Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgTableGeneral;
